import { ClockType } from '@app/entities/enums/mot/clock-type.enum';

export { ClockType };

export class Clocking {
  lastUpdate!: string;
  months!: ClockingMonth[];
}

export class ClockingMonth {
  month!: string;
  days!: ClockingDay[];
}

export class ClockingDay {
  date!: string;
  label!: string;
  clocks!: Clock[];
  hasError!: boolean;
}

export class ClockingRegistry {
  time!: string;
  type!: ClockType;
  date!: string;
}
export class Clock {
  entry!: ClockingRegistry | null;
  exit!: ClockingRegistry | null;
}
